import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';


const routes: Routes = [
  {
    path: 'home-2',
    pathMatch: 'full',
    // loadChildren: 'src/app/home/home.module#HomeModule'
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: '',
    loadChildren: () => import('./homelanding/homelanding.module').then(m => m.HomelandingModule)
  },
  // {
  //   path: 'login',
  //   data: { 'checkout': false, 'login': true },
  //   // loadChildren: './login/login.module#LoginModule'
  //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  // },
  // {
  //   path: 'sign-in',
  //   data: { 'checkout': false, 'login': true },
  //   // loadChildren: './login/login.module#LoginModule'
  //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  // },
  // {
  //   path: 'sign-up',
  //   data: { 'checkout': false, 'login': false },
  //   // loadChildren: './login/login.module#LoginModule'
  //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  // },
  // {
  //   path: 'welcome',
  //   data: { 'guest': false },
  //   // loadChildren: './survey/survey.module#SurveyModule'
  //   loadChildren: () => import('./survey/survey.module').then(m => m.SurveyModule)
  // },
  // {
  //   path: 'welcomeguest',
  //   data: { 'guest': true },
  //   // loadChildren: './survey/survey.module#SurveyModule'
  //   loadChildren: () => import('./survey/survey.module').then(m => m.SurveyModule)
  // },
  // {
  //   path: 'thankyou-quiz',
  //   // loadChildren: './thankyou-quiz/thankyou-quiz.module#ThankyouQuizModule'
  //   loadChildren: () => import('./thankyou-quiz/thankyou-quiz.module').then(m => m.ThankyouQuizModule)
  // },
  // {
  //   path: 'accountinfo',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './account/account.module#AccountModule'
  //   loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  // },
  // {
  //   path: 'myorders',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './orders/orders.module#OrdersModule'
  //   loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule)
  // },
  // {
  //   path: 'productlisting',
  //   // loadChildren: './productlisting/productlisting.module#ProductListingModule'
  //   loadChildren: () => import('./productlisting/productlisting.module').then(m => m.ProductListingModule)
  // },
  // {
  //   path: 'productdetail',
  //   // loadChildren: './productdetail/productdetail.module#ProductDetailModule'
  //   loadChildren: () => import('./productdetail/productdetail.module').then(m => m.ProductDetailModule)
  // },
  // {
  //   path: 'cart/empty',
  //   // loadChildren: './cart/cart.module#CartModule'
  //   loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
  // },
  // {
  //   path: 'cart-placeorder',
  //   // canActivate: [AuthGuard],
  //   // data: {'forcheckout': true},
  //   // loadChildren: './placeorder/placeorder.module#PlaceorderModule'
  //   loadChildren: () => import('./placeorder/placeorder.module').then(m => m.PlaceorderModule)
  // },
  // {
  //   path: 'checkout-summary',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './checkout/checkout.module#CheckoutModule'
  //   loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule)
  // },
  // {
  //   path: 'login-checkout',
  //   data: { 'checkout': true, 'login': true },
  //   // loadChildren: './login/login.module#LoginModule'
  //   loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  // },
  // {
  //   path: 'forgotpassword',
  //   // loadChildren: './forgot-password/forgot-password.module#ForgotPasswordModule'
  //   loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  // },
  // {
  //   path: 'reset-password/:accessToken/:accountID',
  //   // loadChildren: './resetpassword/reset.module#ResetModule'
  //   loadChildren: () => import('./resetpassword/reset.module').then(m => m.ResetModule)
  // },
  // {
  //   path: 'view-receipt',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './viewreceipt/viewreceipt.module#ViewreceiptModule'
  //   loadChildren: () => import('./viewreceipt/viewreceipt.module').then(m => m.ViewreceiptModule)
  // },
  // {
  //   path: 'view-receipt-info',
  //   canActivate: [AuthGuard],
  //   data: { 'info': true },
  //   // loadChildren: './viewreceipt/viewreceipt.module#ViewreceiptModule'
  //   loadChildren: () => import('./viewreceipt/viewreceipt.module').then(m => m.ViewreceiptModule)
  // },
  // {
  //   path: 'add-payment',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './addpayment/addpayment.module#AddpaymentModule'
  //   loadChildren: () => import('./addpayment/addpayment.module').then(m => m.AddpaymentModule)
  // },
  // {
  //   path: 'liquorstoreform',
  //   // loadChildren: './liquorstore/liquorstore.module#LiquorStoreModule'
  //   loadChildren: () => import('./liquorstore/liquorstore.module').then(m => m.LiquorStoreModule)
  // },
  // {
  //   path: 'book-a-bartender',
  //   // loadChildren: './book-a-bartender/book-a-bartender.module#BookABartenderModule'
  //   loadChildren: () => import('./book-a-bartender/book-a-bartender.module').then(m => m.BookABartenderModule)
  // },
  {
    path: 'help',
    // loadChildren: './help/help.module#HelpModule'
    loadChildren: () => import('./help/help.module').then(m => m.HelpModule)
  },
  {
    path: 'terms_of_use',
    // loadChildren: './terms-of-service/terms-of-service.module#TermsOfServiceModule'
    loadChildren: () => import('./terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule)
  },
  {
    path: 'privacy_policy',
    // loadChildren: './privacy-policy/privacy-policy.module#PrivacyPolicyModule'
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
  // {
  //   path: 'company',
  //   // loadChildren: './companylisting/companylisting.module#CompanyListingModule'
  //   loadChildren: () => import('./companylisting/companylisting.module').then(m => m.CompanyListingModule)
  // },
  // {
  //   path: 'gift',
  //   // loadChildren: './giftlanding/giftlanding.module#GiftLandingModule'
  //   loadChildren: () => import('./giftlanding/giftlanding.module').then(m => m.GiftLandingModule)
  // },
  // {
  //   path: 'thankyou-gift',
  //   // loadChildren: './thankyou-gift/thankyou-gift.module#ThankyouGiftModule'
  //   loadChildren: () => import('./thankyou-gift/thankyou-gift.module').then(m => m.ThankyouGiftModule)
  // },
  // {
  //   path: 'recipient',
  //   canActivate: [AuthGuard],
  //   // loadChildren: './recipient/recipient.module#SurveyModule'
  //   loadChildren: () => import('./recipient/recipient.module').then(m => m.RecipientModule)
  // },
  {
    path: 'partner',
    loadChildren: () => import('./partner-page/partner-page.module').then(m => m.PartnerPageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq-page/faq-page.module').then(m => m.FaqPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
